'use strict';

var util = angular.module('gymsystem.util');

util.directive('economydata', [function() {
    return {
        restrict: 'E',
        templateUrl: 'components/widgets/economydata/economydata.html',
        scope: {
            settings: '='
        },
        link: function($scope) {
            var types = [ // TODO: Duplicated
                {id: 'totinc', name: 'Totala inkomster'},
                {id: 'res', name: 'Årets resultat'},
                {id: 'net', name: 'Nettoomsättning'},
                {id: 'misc', name: 'Övrig omsättning'},
                {id: 'due', name: 'Förfallna leverantörsfakturor'},
                {id: 'totexp', name: 'Totala utgifter'},
                {id: 'ass', name: 'Tillgångar'},
                {id: 'winmar', name: 'Vinstmarginal'},
                {id: 'cash', name: 'Kassalikviditet'}
            ];

            $scope.items = $scope.settings.data.map(function(id) {
                var item = angular.copy(_.findWhere(types, {id: id}));
                item.value = Math.floor((Math.random() - 0.5) * 100000);
                return item;
            });
        }
    };
}]);
